var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHomeTabTitlePause = function SvgIconHomeTabTitlePause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.658 3.467H6.566V2.86h-.97v.608H3.49v.773h5.168v-.773Zm-5.434 4.19h1.278v1.484h.991V7.658H6.69V9.14h.998V7.658H8.96v-.78H3.224v.78Zm.656-2.125c0 .697.824 1.083 2.201 1.087 1.37-.004 2.198-.39 2.201-1.087-.003-.7-.83-1.08-2.2-1.08-1.378 0-2.202.38-2.202 1.08Zm1.025 0c-.003-.253.37-.349 1.176-.356.8.007 1.176.103 1.183.356-.007.242-.383.348-1.183.348-.807 0-1.18-.106-1.176-.348ZM14.776 2.859h-.943v2.379h-.43V2.94h-.93V6.94c-.896-.52-1.159-1.535-1.156-2.577V4.26h.896v-.779H9.355v.78h.998v.102c.004 1.172-.263 2.297-1.23 2.844l.602.758c.577-.345.933-.916 1.134-1.61.223.599.585 1.084 1.142 1.378l.472-.626v1.747h.93V6.031h.43v3.103h.943V2.86Z",
    fill: "#A4A7AD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 11,
    rx: 1.5,
    stroke: "#A4A7AD"
  })));
};
export default SvgIconHomeTabTitlePause;